import { render, staticRenderFns } from "./ProductOrganicPage.vue?vue&type=template&id=4c7cbd48&scoped=true&"
import script from "./ProductOrganicPage.vue?vue&type=script&lang=js&"
export * from "./ProductOrganicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cbd48",
  null
  
)

export default component.exports